<template>
  <div id="app">
    <router-view/>
    
  </div>
</template>
<script>

//   import CommonHeader from "./components/CommonHeader.vue";
//   import CommenNav from "./components/CommenNav.vue";
//   import ComBanner from "./components/ComBanner.vue";
// import ComFoot from "./components/ComFoot.vue";

// import { RouterLink } from "vue-router";
  export default {
      // components:{ RouterLink}
    
  }
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
